<section class="py-10 overflow-hidden">
  <h2 class="text-center text-sm mb-10 text-[#ccd3df]" data-aos="fade-up">
    {{ 'recruiterProgram.trustedBy.title' | translate }}
  </h2>

  <div class="logos-marquee" data-aos="fade-up" data-aos-delay="100">
    <div class="logos-track">
      <div class="logo-item" *ngFor="let logo of companyLogos">
        <img [src]="logo.src" [alt]="logo.alt" loading="lazy">
      </div>
      <div class="logo-item" *ngFor="let logo of companyLogos">
        <img [src]="logo.src" [alt]="logo.alt" loading="lazy">
      </div>
    </div>
  </div>
</section>
